import React from 'react';

interface AccountHeaderProps {
  amountToDeposit?: number;
}

const AccountHeader: React.FC<AccountHeaderProps> = ({ amountToDeposit }) => {
  return (
    <>
      {amountToDeposit && (
        <div className="mb-4 text-start">
          <h5 className="greenColour">My Wages: ${amountToDeposit.toLocaleString()}</h5>
          <h5 className="">Choose your destination account</h5>
        </div>
      )}
    </>
  );
};

export default AccountHeader;